import React, { Component } from 'react';
import {isosLogo} from '../../conf/config';

class Header extends Component{
  render() {
    return (
      <header className="header">
        <div className="container">
          <img
            className="img-responsive center-block"
            src={this.props.logo}
            style={{maxHeight: 130}}/>
          <img
            alt="creative star"
            style={{color: '#fff'}}
            className="img-responsive center-block"
            src={isosLogo}/>
        </div>
      </header>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/component/header/index.js